// extracted by mini-css-extract-plugin
module.exports = {"root":"_3AMdmRg"};
    if(module.hot) {
      // 1545369440840
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  